import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import api from "../../services/api";
import openSocket from "../../services/socket-io";
import { AuthContext } from "../Auth/AuthContext";

const InboxContext = createContext({ unreadCount: 0, revision: 0, refresh: () => {} });

export const InboxProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const [revision, setRevision] = useState(0);
  const generation = useRef(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);

  useEffect(() => {
    setUnreadCount(0);
    generation.current += 1;
    if (!user?.id) return undefined;
    const socket = openSocket();
    socket.on("inbox", refresh);
    socket.on("connect", refresh);
    const onVisible = () => { if (!document.hidden) refresh(); };
    const poll = setInterval(onVisible, 30000);
    window.addEventListener("focus", onVisible);
    document.addEventListener("visibilitychange", onVisible);
    refresh();
    return () => {
      generation.current += 1;
      socket.disconnect();
      clearInterval(poll);
      window.removeEventListener("focus", onVisible);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [user?.id, user?.companyId, refresh]);

  useEffect(() => {
    if (!user?.id) return undefined;
    let active = true;
    const current = generation.current;
    api.get("/inbox", { params: { unreadOnly: true, pageNumber: 1 } })
      .then(({ data }) => {
        if (active && current === generation.current) setUnreadCount(data.unreadCount || 0);
      })
      .catch(() => { /* A página exibe falhas e permite tentar novamente. */ });
    return () => { active = false; };
  }, [user?.id, user?.companyId, revision]);

  return <InboxContext.Provider value={{ unreadCount, revision, refresh }}>{children}</InboxContext.Provider>;
};

export const useInbox = () => useContext(InboxContext);
